import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import {
  Schema,
  SchemaMetadataModel,
  DynamicSchemaFacade,
  DynamicSchemaFactory,
  SchemaMetadataFacade,
  DynamicContentSchemaFactory,
  DynamicContentModel,
  DynamicContentSchemaFacade,
  SchemaPageModel,
  LanguageModel,
  FilterPagination
} from '../../../services';

import { ActivatedRoute} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../../../base/base-component.component';
import { AppSchemaCategory } from '../../../models/app-token';
import { map, mergeMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { FieldReferenceContent } from '../../../shared/field/tools/field-reference-content.service';
import { ESchemaContentStatus } from '../../../services/akita/base/enum';
import { ContentEditionComponent } from '../../../shared/content/content-edition/content-edition.component';


@Component({
  selector: 'schema-page',
  templateUrl: './schema-page.component.html',
  styleUrls: ['./schema-page.component.css']
})
export class SchemaPageComponent extends BaseComponent implements OnInit {
  schemaSelectedName = '';
  schemaSelectedLabel = '';
  contentSelectedCode = '';

  schemaDefinition: Schema;
  schemaMetadata: SchemaMetadataModel;
  listableSchemas: Schema[];

  currentSchemaFacade: DynamicSchemaFacade;
  currentContentsFacade: DynamicContentSchemaFacade;

  selectedSchemaContents: DynamicContentModel[];
  selectedContent: DynamicContentModel;

  referenceFieldValues: any;
  referenceFieldValues$: Observable<any>;
  orderBySwitch: boolean;

  @ViewChild("contentEdition", null) contentEditionComponent: ContentEditionComponent;

  @Output()
  onUpdatePage = new EventEmitter<any>();

  constructor(
    private readonly dynamicSchemaFacto: DynamicSchemaFactory,
    private readonly dynamicContentSchemaFactory: DynamicContentSchemaFactory,
    private readonly route: ActivatedRoute,
    private readonly metadataFacade: SchemaMetadataFacade,
    private readonly referenceContentService: FieldReferenceContent,
    translateService: TranslateService) {
    super(translateService);
    this.setTranslateContext('SchemaPageComponent');
  }

  ngOnInit() {
    const sub1 = this.dynamicSchemaFacto
      .getSchemasMetadataByCategory(AppSchemaCategory.SCHEMA_AS_A_PAGE).pipe(mergeMap(defaults => {
        return this.dynamicSchemaFacto
          .getSchemasMetadataByCategory(AppSchemaCategory.CONTENT_SCHEMAS).pipe(map(contents => {
            return defaults.concat(contents).sort(this.sortByName);
          }));
      }))
      .subscribe(result => {
        this.listableSchemas = result.filter(meta => meta.name.length <= 40);
      });

    this.subscriptions.push(sub1);

    this.updateObservable();
  }

  updateObservable() {
    this.schemaSelectedName = this.route.snapshot.paramMap.get('name');
    this.contentSelectedCode = this.route.snapshot.paramMap.get('code');

    if (this.schemaSelectedName && this.schemaSelectedName.length > 0) {
      this.currentSchemaFacade = this.dynamicSchemaFacto.getDynamicSchemaFacade(this.schemaSelectedName);


      this.referenceFieldValues$ = this.currentSchemaFacade
        .getSchemaDefinition()
        .pipe(mergeMap(result => {
          this.schemaDefinition = result;
          this.schemaSelectedLabel = this.schemaDefinition["properties"]["label"];
          return this.referenceContentService.generateContentList(result);
        }));

      var sub = this.referenceFieldValues$.subscribe();
      this.subscriptions.push(sub);

      const sub1 = this.metadataFacade
        .getByCode(this.schemaSelectedName)
        .subscribe(result => this.schemaMetadata = result);

      this.subscriptions.push(sub1);

      this.currentContentsFacade = this.dynamicContentSchemaFactory
        .getDynamicContentSchemaFacade(this.schemaSelectedName);

      this.filterValue = this.route.snapshot.paramMap.get('filter');
      this.currentPageNumber = Number(this.route.snapshot.paramMap.get('page'));

      if (this.filterValue === null) {
        this.filterValue = '';
      }

      const filterObject = {
        or:
          [
            {
              path: 'data.code.iv',
              op: 'contains',
              value: this.filterValue
            }
          ]
      }

      const filter = new FilterPagination();

      filter.from = (this.currentPageNumber - 1) * this.paginateSize;
      filter.to = filter.from + this.paginateSize;
      filter.orderBy = 'data.index.iv ascending,data.code.iv ascending';
      filter.filterObject = this.getSearchObject(this.filterValue);

      this.currentContentsFacade.getFilteredPagination(filter, ESchemaContentStatus.All, filterObject)
        .subscribe(contents => {
          this.selectedSchemaContents = contents;
          this.currentContentsFacade.fullCount().subscribe(c => {
            this.contentCount = c;
          });
        });

      if (this.contentSelectedCode && this.contentSelectedCode.length > 0) {

        this.currentContentsFacade.getByCode(this.contentSelectedCode, true).subscribe(c => {
          this.selectedContent = c;
        });
      }

    } else {
      this.schemaDefinition = null;
      this.schemaMetadata = null;
    }
  }

  getSearchObject(filter): object {
    const oSearch = {
      or:
        [
          {
            path: 'data.code.iv',
            op: 'contains',
            value: filter
          }
        ]
    }
    return oSearch;
  }

  getPageData($event) {
    this.currentPageNumber = $event.page;
    this.search(null, true);
  }

  updateChild(updateParent = true) {
    this.contentEditionComponent.updateContent(updateParent);
  }

  onUpdate() {
    if (this.onUpdatePage) {
      this.onUpdatePage.emit();
    }
  }



}
